// extracted by mini-css-extract-plugin
export default {"link":"style-module--link--554e8","home":"style-module--home--2a18e"};